import { PeriodModel } from "../PeriodModel"
import { FinancialPeriodResourceV2ApiUpdateFinancialPeriodsRequest } from "../../../client/backend-client/generated"
import { incomeStatementToInput } from "../../../utils/IncomeStatementMapper"

export const periodToMutationModel = (
  noteId: string,
  periods: PeriodModel[]
): FinancialPeriodResourceV2ApiUpdateFinancialPeriodsRequest => ({
  noteId,
  saveFinancialPeriodRequest: periods.map(period => ({
    id: period.id,
    incomeStatement: incomeStatementToInput(period.incomeStatement),
    prelevementTns: period.prelevementTns
  }))
})
